import ViewProduct from "./view_product";
import CountryProducts from "../../components/CatalogStore/country_products.js";
// const CountryProducts = React.lazy(() => import("../../components/CatalogStore/country_products"));
import CountryPackages from "./subscription/country_packages.js";
import CatalogSpecialPackage from "./subscription/catalog_special_package.js";
import { SubscriptionProvider } from "./catalog_context.js";
import Loading from "../../components/loading.js";

const t0 = performance.now();
function renderCallback(e) {
    console.log("Rendering done", e);
    const t1 = performance.now();

    console.log(`Mount took ~${(t1 - t0) / 1000} seconds.`);
}

class CatalogView extends React.Component {

    render(){
        let renderPage;
        if(window.location.pathname.includes("bundle")){
            renderPage = <ViewProduct/>
        } else {
            renderPage = <React.Fragment>
                <CountryProducts/>
            </React.Fragment>
        }
        return renderPage;
    }
}
const addonsElContainer = document.querySelector('#country_products_container');
if(addonsElContainer){
    ReactDOM.render(
        <CatalogView />,
        addonsElContainer
    );
}

class CatalogPackage extends React.Component {

    constructor(props) {
        super(props);
        this.handlerRef = React.createRef();
    }

    updateUI(){
        if(this.handlerRef.current){
            this.handlerRef.current.updatePackages();
        }
    }

    render() {
        return(
            <CountryPackages ref={this.handlerRef}/>
        )
    }
}
const packageElContainer = document.querySelector('#country_subscription_container');
if(packageElContainer){
    CountryPackageRender = ReactDOM.render(
        <CatalogPackage />,
        packageElContainer
    );
}

const specialPackageElContainer = document.querySelector('#special_subscription_container');
if(specialPackageElContainer){
    ReactDOM.render(
        <SubscriptionProvider>
            <CatalogSpecialPackage />    
        </SubscriptionProvider>,
        specialPackageElContainer
    )
}